<template>
    <div class="container">
        <h1 style="position: absolute">
                <span class="typed-text">{{ typeValue }}</span>
            <span class="cursor" :class="{'typing': typeStatus}">&nbsp;</span>
            </h1>

    </div>
</template>

<script>
    import { setTimeout } from 'timers';
    export default {
        name: 'TypeEffect',
        data: () => {
            return {
                typeValue: '',
                typeStatus: false,
                typeArray: ['WEB', 'MARKET', 'WORLD'],
                typingSpeed: 200,
                erasingSpeed: 100,
                newTextDelay: 2000,
                typeArrayIndex: 0,
                charIndex: 0
            }
        },
        methods: {
            typeText() {
                if(this.charIndex < this.typeArray[this.typeArrayIndex].length) {
                    if(!this.typeStatus)
                        this.typeStatus = true;
                    this.typeValue += this.typeArray[this.typeArrayIndex].charAt(this.charIndex);
                    this.charIndex += 1;
                    setTimeout(this.typeText, this.typingSpeed);
                }
                else {
                    this.typeStatus = false;
                    setTimeout(this.eraseText, this.newTextDelay);
                }
            },
            eraseText() {
                if(this.charIndex > 0) {
                    if(!this.typeStatus)
                        this.typeStatus = true;
                    this.typeValue = this.typeArray[this.typeArrayIndex].substring(0, this.charIndex - 1);
                    this.charIndex -= 1;
                    setTimeout(this.eraseText, this.erasingSpeed);
                }
                else {
                    this.typeStatus = false;
                    this.typeArrayIndex += 1;
                    if(this.typeArrayIndex >= this.typeArray.length)
                        this.typeArrayIndex = 0;
                    setTimeout(this.typeText, this.typingSpeed + 1000);
                }
            }
        },
        created() {
            setTimeout(this.typeText, this.newTextDelay + 200);
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
    }
    h1 {
        font-size: 100px;;
        font-weight: normal;
        color: white;
        span.typed-text {
            color: #FFD700;
        }
        span.cursor {
            display: inline-block;
            margin-left: 3px;
            width: 4px;
            background-color: white;
            animation: cursorBlink 1s infinite;
        }
        span.cursor.typing {
            animation: none;
        }
    }
    @keyframes cursorBlink {
        49% { background-color: white; }
        50% { background-color: transparent; }
        99% { background-color: transparent; }
    }

    @media only screen and (min-width: 600px) and (max-width: 759px) {
        h1 {
            font-weight: bold;
            font-size: 70px;
            letter-spacing: 5px;
        }
    }

    @media only screen and (min-width: 760px) and (max-width: 1000px) {
        h1 {
            font-weight: bold;
            font-size: 90px;
            letter-spacing: 5px;
        }
    }

    @media only screen and (min-width: 300px) and (max-width: 599px) {
        h1 {
            font-weight: bold;
            font-size: 50px;
            letter-spacing: 5px;
        }
    }

    @media only screen and (max-width: 374px) {
        h1 {
            font-weight: bold;
            font-size: 40px;
            letter-spacing: 5px;
        }
    }

</style>
